<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
button.disabled {
  cursor: no-drop;
}
td button.btn.status {
  cursor: auto;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-xl-6 col-md-6 col-sm-12 d-flex">
        <div class="card bg-primary text-white flex-fill">
          <div class="row">
            <div class="col-md-9">
              <div class="card-body">
                <div class="mb-3">
                  <h3>{{ detailUser.nama_lengkap || 'Nama Lengkap' }}</h3>
                  
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mb-3">
              <i
                style="
                  height: 40px;
                  width: 40px;
                  opacity: 0.8;
                  float: right;
                  margin-right: 13px;
                "
                class="c-sidebar-nav-icon fa fa-user opacity-7"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 d-flex">
        <div class="card bg-primary text-white flex-fill">
          <div class="row">
            <div class="col-md-9">
              <div class="card-body">
                <div class="mb-3">
                  <h3>{{ detailUser.nama_sertifikasi || 'Nama Sertifikasi' }}</h3>
                  <span class="font-weight-bold" style="font-size:20px">Periode {{ detailUser.periode }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mb-3">
              <i
                style="
                  height: 40px;
                  width: 40px;
                  opacity: 0.8;
                  float: right;
                  margin-right: 13px;
                "
                class="c-sidebar-nav-icon fas fa-file-alt opacity-7"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Mata Uji {{ detailUser.nama_sertifikasi }}
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <div>
        <CCardBody>
          <CRow>
            <CCol lg="12" class="table-responsive">
              <CDataTable
                style="widht:100% !important"
                :items="items"
                :fields="detailUser.kategori_rpl == 'workshop' ? fieldsWorkshop : fields"
                :items-per-page-select='{ label : "Data Per Halaman", class: "float-right" }'
                :tableFilter='{ label:"Pencarian", placeholder:"Cari Data ..", class: "float-left" }'
                hover
                sorter
                :pagination='{ class: "float-right" }'
              >              
                <template #no="{index}">
                  <td class="py-2">{{ index += 1 }}</td>
                </template>              
                <template #nama_mata_uji="{item}">
                  <td class="py-2 text-left">{{ item.nama_mata_uji ? item.nama_mata_uji : '-' }}</td>
                </template>
                <template #nilai="{item}">
                  <td class="py-2 text-left">{{ item.nilai ? item.nilai : '0' }}</td>
                </template>
                <template #status_pembayaran="{item}">
                  <td
                    class="py-2 text-success text-center font-weight-bold"
                    v-if="item.status_pembayaran == 'settlement'"
                  >Lunas</td>
                  <td
                    class="py-2 text-purple text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'pending'"
                  >Menunggu Pembayaran</td>
                  <td
                    class="py-2 text-secondary text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'expired'"
                  >Expired</td>
                  <td
                    class="py-2 text-secondary text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 'failure'"
                  >Pembayaran Gagal</td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else-if="item.status_pembayaran == 0"
                  >Belum Dibayar</td>
                  <td 
                    v-else-if="item.status_bypass == '1'" 
                    class="py-2 text-success text-center font-weight-bold">
                    Lunas
                  </td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else
                  >Belum Lunas</td>
                </template>    
                <template #kehadiran="{item}">
                  <td
                    class="py-2 text-success text-center font-weight-bold"
                    v-if="item.kehadiran == '1'"
                  >Mengikuti</td>
                  <td
                    class="py-2 text-danger text-center font-weight-bold"
                    v-else-if="item.kehadiran == '0'"
                  >Tidak Mengikuti</td>
                  <td
                    class="py-2 text-primary text-center font-weight-bold"
                    v-else
                  >Belum Mengikuti</td>
                </template>            
                <template #status_pembatalan="{ item }">
                  <td class="py-2 text-center">
                    <i
                      class="fa fa-check text-success"
                      aria-hidden="true"
                      v-if="item.status_pembatalan == 1"
                    ></i>
                    <font-awesome-icon
                      icon="times"
                      class="text-danger"
                      v-else
                    />
                  </td>
                </template>
                <template #status_refund="{ item }">                  
                  <td class="py-2 text-center">                    
                    <font-awesome-icon
                      v-if="item.status_refund === '1'"
                      icon="check"
                      class="text-success"
                      aria-hidden="true"
                    />
                    <font-awesome-icon
                      v-else
                      icon="times"
                      class="text-danger"                      
                      aria-hidden="true"
                    />
                  </td>
                </template>    
                <template #aksi_workshop="{item}">
                  <td class="py-2 text-center">
                    <CButton
                      v-c-tooltip="'Ubah Kehadiran'"
                      @click="aksiKehadiran(item, index)"
                      color="success"
                      class="btn-sm"
                      square
                    >
                      <font-awesome-icon icon="edit" class="text-white" />
                    </CButton>
                  </td>
                </template>            
                <template #aksi="{ item }">
                  <td class="py-2 text-center">
                    <CButton
                      v-c-tooltip="'Reschedule'"
                      @click="aksiReschedule(item, index)"
                      :disabled="item.status_pembatalan == 0 || item.status_pembatalan === null"
                      color="success"
                      class="btn-sm"
                      square
                    >
                      <font-awesome-icon icon="calendar" class="text-white" />
                    </CButton>
                    &nbsp;&nbsp;
                    <CButton
                      v-c-tooltip="'Refund'"
                      @click="aksiRefund(item, index)"
                      :disabled="item.status_refund === null"
                      color="warning"
                      class="btn-sm"
                      square
                    >
                      <font-awesome-icon icon="coins" class="text-white" />
                    </CButton>
                    &nbsp;&nbsp;
                  </td>
                </template>
              </CDataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
    </CCard>     

    <!-- Modal Kehadiran -->
    <CModal
      title="Modal title"
      :show.sync="modalKehadiran"
      :no-close-on-backdrop="true"
      :centered="true"
      size="md"
    >
      <CRow>
        <CCol sm="12">
          <div class="form-group">
            <label for="nama_dokument" class="font-weight-bold">Kehadiran</label>
            <select name="" id="" class="form-control" v-model="formKehadiran.kehadiran">
              <option :value="''" selected disabled>Pilih Status Kehadiran</option>
              <option value="1">Mengikuti</option>
              <option value="0">Tidak Mengikuti</option>
            </select>
          </div>
          <div class="form-group">
            <label for="nilai" class="font-weight-bold">Nilai</label>
            <input type="number" min="0" max="100" class="form-control" placeholder="Masukkan Nilai" v-model="formKehadiran.nilai">
          </div>
        </CCol>
      </CRow>
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Kehadiran</h6>
      </template>
      <template #footer>
        <CButton @click="modalKehadiran = false" color="danger">Tutup</CButton>
        <CButton @click="postKehadiran" type="submit" color="success">Simpan</CButton>
      </template>
    </CModal>
    <!-- Modal Kehadiran -->

    <!-- Modal Reschedule -->
    <CModal
      title="Modal title"
      :show.sync="modalReschedule"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
    >
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail Reschedule</h6>
      </template>
      <CRow class="px-3">
        <CCard class="w-100">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Test Center</CCardHeader>
          <table class="table table-bordered font-weight-bold mb-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Test Center</th>
                <th>Tanggal Ujian</th>
                <th>Waktu Ujian</th>
                <th>Sesi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ formData.nama_tc ? formData.nama_tc : '-' }}</td>
                <td>{{ formData.tanggal_ujian ? formData.tanggal_ujian : '-' }}</td>
                <td>{{ formData.waktu ? formData.waktu : '-' }}</td>
                <td>{{ formData.sesi ? formData.sesi : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </CCard>

        <CCard class="w-100 mt-3">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Riwayat Test Center</CCardHeader>
           <CDataTable 
              style="widht:100% !important" 
              :items="dataRiwayatReschedule" 
              :fields="fieldsRiwayatReschedule"
              hover 
              sorter
            >            
            <template #no="{ index }">
              <td class="py-2">{{ index += 1 }}</td>
            </template>
            <template #nama_tc="{item}">
              <td class="py-2 text-center">{{item.nama_tc ? item.nama_tc : "-"}}</td>
            </template>
            <template #tanggal_ujian="{item}">
              <td class="py-2 text-center">{{item.tanggal_ujian ?  item.tanggal_ujian : "-"}}</td>
            </template>
            <template #waktu="{item}">
              <td class="py-2 text-center">{{item.waktu ? item.waktu : "-"}}</td>
            </template>                    
          </CDataTable>         
        </CCard>

        <CCard class="w-100 mt-3">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Riwayat Test Center</CCardHeader>
          <table class="table font-weight-bold mb-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Test Center</th>
                <th>Tanggal Ujian</th>
                <th>Waktu Ujian</th>
                <th>Sesi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ dataRiwayatTestCenter.nama_tc || '-' }}</td>                
                <td>{{ dataRiwayatTestCenter.tanggal_ujian || '-' }}</td>
                <td>{{ dataRiwayatTestCenter.waktu || '-' }}</td>
                <td>{{ dataRiwayatTestCenter.sesi || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </CCard>

      </CRow>      
      <template #footer>
        <CButton @click="modalReschedule = false" color="danger">Tutup</CButton>        
      </template>
    </CModal>
    <!-- End Modal Reschedule -->

    <!-- Modal Refund -->
    <CModal
      title="Modal title"
      :show.sync="modalRefund"
      :no-close-on-backdrop="true"
      :centered="true"      
    >
      <CRow >
        <div class="modal-body row my-n3">
            <div class="col-5">
                <p class="font-weight-bold">Kode Pembayaran</p>
                <p class="font-weight-bold">Nama Anggota</p>
                <p class="font-weight-bold">Nama Sertifikasi</p>
                <p class="font-weight-bold">Kategori Anggota</p>
                <p class="font-weight-bold">No. Handphone</p>
                <p class="font-weight-bold">No. Telepon</p>
                <p class="font-weight-bold">Email</p>
                <p class="font-weight-bold">Bank</p>
                <p class="font-weight-bold">Nama Rekening</p>
                <p class="font-weight-bold">No. Rekening</p>
                <p class="font-weight-bold">Bukti Refund</p>
                <p class="font-weight-bold">Status Approval Keuangan</p>
                
            </div>
            <div class="col-7">
                <p>: {{ formData.id_invoice ? formData.id_invoice : ' - ' }}</p>
                <p>: {{ detailUser.nama_lengkap ? detailUser.nama_lengkap : ' - ' }}</p>
                <p>: {{ detailUser.nama_sertifikasi ? detailUser.nama_sertifikasi : ' - ' }}</p>
                <p>: {{ detailUser.kategori_anggota ? detailUser.kategori_anggota : ' - ' }}</p>
                <p>: {{ detailUser.no_handphone ? detailUser.no_handphone : ' - ' }}</p>
                <p>: {{ detailUser.no_telephone ? detailUser.no_telephone : ' - ' }}</p>
                <p>: {{ detailUser.email ? detailUser.email : ' - ' }}</p>
                <p>: {{ formData.nama_bank ? formData.nama_bank : ' - ' }}</p>
                <p>: {{ formData.nama_rekening ? formData.nama_rekening : ' - ' }}</p>
                <p>: {{ formData.no_rekening ? formData.no_rekening : ' - ' }}</p>
                <p>: <button 
                    :class="formData.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                    :disabled="formData.file_bukti_refund === null" 
                    @click="lihatFile(formData.file_bukti_refund)">
                    Lihat File
                    </button>
                </p>
                <p>: 
                    <span class="text-success font-weight-bold" v-if="formData.status_approval_keuangan == '1' ">Disetujui</span>
                    <span class="text-danger font-weight-bold" v-else-if="formData.status_approval_keuangan == '0'">Ditolak</span>
                    <span class="text-warning font-weight-bold" v-else>Menunggu</span>
                  
                </p>
                
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="" class="font-weight-bold">Alasan</label>
                    <textarea  
                    class="form-control"
                        cols="30"
                        readonly
                        v-model="formData.keterangan" 
                        rows="5">
                    </textarea>
                </div>
                <div class="form-group">
                    <label for class="font-weight-bold">Status</label>
                    <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input
                            type="radio"
                            class="custom-control-input"
                            name="customRadio"
                            id="aktif_refund"
                            value="1"
                            :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null"
                            v-model="formData.status_pembatalan"                                
                        />
                        <label class="custom-control-label" for="aktif_refund">Disetujui</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input
                            type="radio"
                            class="custom-control-input"
                            name="customRadio"
                            id="tidak_aktif_refund"
                            value="2"
                            :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null"
                            v-model="formData.status_pembatalan"                                
                        />
                        <label class="custom-control-label" for="tidak_aktif_refund">Ditolak</label>
                    </div>
                    </div>
                </div>
            </div>
        </div>
      </CRow>
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail Refund</h6>
      </template>
      <template #footer>
        <CButton @click="modalRefund = false" color="danger">Tutup</CButton>
        <CButton @click="postStatusRefund" type="submit" color="success" :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null">Simpan</CButton>
      </template>
    </CModal>
    <!-- End Modal Refund -->

    <!-- End Data Sertifikasi -->
  </div>
</template>
<script>
import { AlertUtils } from "@/mixins/AlertUtils";
import DataPesertaRplService from '@/services/rpl/data-peserta-rpl.service'
import { fieldsRiwayatReschedule } from "@/const-data/sertifikasi/data-peserta/fields-table" 
import Utils from "@/services/utils.service";
const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,    
  },
  {
    key: "nama_mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: true,
    _style: "text-align: left",
  }, 
  {
    key: "nilai",
    label: "Nilai",
    sorter: true,
    filter: true,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: true,
    _style: "text-align: center",
  },  
  {
    key: "status_pembatalan",
    label: "Status Reschedule",
    sorter: true,
    filter: true,
    _style: "text-align: center",
  },  
  {
    key: "status_refund",
    label: "Status Refund",
    sorter: true,
    filter: true,
    _style: "text-align: center",
  },  
  {
    key: "aksi",
    _style: "width:15%; text-align: center",
    sorter: false,
    filter: false,
  },
];

const fieldsWorkshop = [
  {
    key: "no",
    sorter: true,
    filter: false,    
  },
  {
    key: "nama_mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: true,
    _style: "text-align: left",
  }, 

  {
    key: "nilai",
    label: "Nilai",
    sorter: true,
    filter: true,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: true,
    _style: "text-align: center",
  },  
  {
    key: "kehadiran",
    label: "Status Kehadiran",
    sorter: true,
    filter: true,
    _style: "text-align: center",
  },  
  {
    key: "aksi_workshop",
    label: "Aksi",
    _style: "width:15%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  name: "detail-data-peserta-rpl",
  mixins : [
    AlertUtils
  ],
  data() {
    return {      
      items: [],
      dataRiwayatReschedule: [],
      dataRiwayatTestCenter: [],
      fieldsRiwayatReschedule,
      detailUser: {},      
      formData: {},
      formDataRefund: {},
      formKehadiran : [
        {
          kehadiran: '',
          nilai: 0,
          id_mata_uji_peserta: ''
        }
      ],
      fields,
      fieldsWorkshop,
      currentPage: 3,
      details: [],
      no: 1,
      modalKehadiran : false,
      status: false,      
      modalReschedule: false,
      modalRefund: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {    
    this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_rpl_peserta);
  },
  methods: {    
    lihatFile(item) {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item+"/lokasi/file_refund/bearer/" + token,
        item.file,
        params
      );
    },
    aksiKehadiran(item, index) {
      this.formKehadiran = item;
      this.modalKehadiran = true;
      this.formKehadiran = {
        id_mata_uji_peserta : item.id_mata_uji_peserta,
        kehadiran : item.kehadiran,
        nilai : item.nilai
      }
    },  
    postKehadiran() {
      var loader = this.loaders();

      DataPesertaRplService.putKehadiran(this.formKehadiran)
      .then(() => {
        this.modalKehadiran = false;
        
        loader.hide();

        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_rpl_peserta);
        this.alertSuccess("Berhasil Memperbaharui Kehadiran.");
      }).catch(() => {
        loader.hide();

        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_rpl_peserta);
        this.alertError("Gagal Memperbaharui Kehadiran.")
      })
    },
    postStatusRefund() {
      var loader = this.loaders();      
      DataPesertaRplService.putStatusRefundMataUjiPeserta(this.formDataRefund)
      .then(() => {
        this.modalRefund = false;
        loader.hide();
        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_rpl_peserta);
        this.alertSuccess("Berhasil Memperbaharui Status Refund.");
      }).catch(() => {
        loader.hide();
        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_rpl_peserta);
        this.alertError("Gagal Memperbaharui Status Refund.")
      })
    },    

    aksiReschedule(item, index) {
      var vm = this;
      this.modalReschedule = true;
      this.formData = item;    
      var loaders = this.loaders()      
      DataPesertaRplService.getDetailReschedule(item.id_mata_uji_peserta)
        .then((response) => {                  
          this.dataRiwayatReschedule = response.data.data;               
          this.dataRiwayatTestCenter = response.data.anotherData;
          loaders.hide()
        })
        .catch((error) => {
          // comment console console.log(error);
          loaders.hide()
        });
    },

    aksiRefund(item, index) {
      this.modalRefund = true;
      this.formData = item;
      this.formDataRefund.id_mata_uji_peserta = item.id_mata_uji_peserta
      this.formDataRefund.status_pembatalan = item.status_refund
      this.formDataRefund.file_bukti_refund = item.file_bukti_refund
      this.formDataRefund.nama_rekening = item.nama_rekening
      this.formDataRefund.no_rekening = item.no_rekening
      this.formDataRefund.nama_bank = item.nama_bank
    },                

    getData(currentPage, pageSize, filter, idSertifikasiPesertaRpl) {
      var loaders = this.loaders()
      var vm = this;
      DataPesertaRplService.getDataPesertaSertifikasiRplMataUji(
        currentPage,
        pageSize,
        filter,
        idSertifikasiPesertaRpl
      )
        .then((response) => {          
          // comment console console.log(response)
          vm.items = response.data.data;          
          vm.detailUser = response.data.anotherData;
          loaders.hide();
        })
        .catch((error) => {
          // comment console console.log(error);
          loaders.hide()
        });
    },

    loaders() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      return loader;
    }
  }
};
</script>